import React from 'react';
import { useTranslation } from "react-i18next";
import ScaleLoader from "react-spinners/ScaleLoader";

function CompLoaderDt() {

    return (
        <React.Fragment>
            <br />
            <ScaleLoader color="#373b3e" />
        </React.Fragment>
    );
}
export default CompLoaderDt;